export const STATUS =Object.freeze( {
	"APROBADO" : 1,
    "RECHAZADO" : 2,
    "PROCESO" : 3,
    "SALIO" : 4,
    "FINALIZADO" : 5,
})

export const REQUEST_DISABLE_DATE = {month: 7, day: 10}
export const MINIMUM_PAYMENT=200
export const MINIMUM_PAYMENT_MONTHLY_TEXT=`${MINIMUM_PAYMENT * 2}.00 (cuatrocientos pesos 00/100, m.n.) mensuales`
